import { Guide } from "@common/models";
import { TourPlaybackManager } from "./tourPlayback";
import { Checklist } from "@common/schemas/checklist";
import { ChecklistScheduleReason } from "../scheduler/scheduler";
import { ChecklistCompletionState, ChecklistManager } from "../checklist/checklistManager";
export interface TourLifecycleManagerEvents {
  tourInitialized: { guide: Guide; tour: TourPlaybackManager };
  tourStarted: { guide: Guide };
  tourFinished: { guide: Guide };
  tourTerminated: { guide: Guide };
  tourDismissed: { guide: Guide };
  tourSwitched: { guideId: string };
  checklistStarted: { checklist: Checklist; scheduleReason: ChecklistScheduleReason };
  checklistInitialized: { checklist: Checklist; checklistManager: ChecklistManager };
  checklistDismissed: { checklist: Checklist; completionState: ChecklistCompletionState };
  checklistCompleted: { checklist: Checklist };
  checklistTerminated: { checklist: Checklist };
  tourStartTriggeredFromChecklist: { checklist: Checklist; guideId: string; completionState: ChecklistCompletionState };
  checklistExpandedFromAvatar: { checklist: Checklist; completionState: ChecklistCompletionState };
  checklistMinimized: { checklist: Checklist; completionState: ChecklistCompletionState };
  checklistExpanded: { checklist: Checklist; completionState: ChecklistCompletionState };
  checklistDisplayed: { checklist: Checklist; completionState: ChecklistCompletionState };
}

export type TourLifecycleEventContext = {
  guide?: Guide;
};

export const TourLifecycleNamespace = "tourLifecycle" as const;
